import type {
  AnonymousUser,
  Group,
  UserInformation,
  UserInformationService,
} from '@application/UserInformationService';

export class CompositeUserInformationService implements UserInformationService {
  private userInformationServices: Array<UserInformationService>;

  constructor(userInformationServices: Array<UserInformationService>) {
    this.userInformationServices = userInformationServices;
  }

  setUserInformation = (user: UserInformation | AnonymousUser) => {
    this.userInformationServices.forEach(service =>
      service.setUserInformation(user),
    );
  };

  setGroup = (group: Group | null) => {
    this.userInformationServices.forEach(
      service => service.setGroup && service.setGroup(group),
    );
  };
}
